const toast_config = {
    position:"top-right",
    autoClose:2500,
    hideProgressBar:false,
    closeOnClick:true,
    pauseOnHover:false,
    draggable:false,
    theme:"colored"
}
export default toast_config